module.exports = __webpack_public_path__ + "img/device.d4f4607c.svg";